module.exports = __webpack_public_path__ + "source-sans-pro-v11-latin-italic-63f8016b44fdfba05ac1134209dacca1.bundle.woff";